import {ICounterpartiesRepository} from "@/repository/finance/counterparties/CounterpartiesRepository.types";
import {ICounterparties, ICounterpartiesListItem, CounterpartiesResponseType} from "@/entity/finance/counterparties/counterparties.types";
import Api from "@/repository/api";
import Counterparties from "@/entity/finance/counterparties/counterparties";
import {CounterpartiesGeneralRequestType} from "@/form/finance/counterparties/CounterpartiesGeneral.types";
import qs from "qs";
import {PaginationRequestType} from "@/entity/common/pagination.types";
import {ResponseDataType} from "@/form/form.types";

export class CounterpartiesRepository implements ICounterpartiesRepository {
    async fetchAll(data?: FormData): Promise<ICounterparties> {
        const response = await Api.get(`/finance/counterparties/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
            return new URLSearchParams(params).toString()
        }});
        const responseData = response.data as CounterpartiesResponseType;
        return new Counterparties(responseData);
    }
    async fetchData(data: PaginationRequestType): Promise<ICounterpartiesListItem> {
        const response = await Api.get(`/finance/counterparties/get`, {params: data, paramsSerializer: function paramsSerializer(params) {
                return qs.stringify(params, {arrayFormat: 'repeat'})
            }});
        const responseData = response.data as CounterpartiesResponseType;
        return new Counterparties(responseData).data[0];
    }
    async create(data: CounterpartiesGeneralRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/counterparties/create`, data);
        const responseData = response.data;
        return responseData;
    }
    async import(data: FormData): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/counterparties/import`, data);
        const responseData = response.data;
        return responseData;
    }
    async export(): Promise<ResponseDataType> {
        const response = await Api.get(`/finance/counterparties/export`);
        const responseData = response.data;
        return responseData;
    }
    async update(data: CounterpartiesGeneralRequestType): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/counterparties/update`, data);
        const responseData = response.data;
        return responseData;
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const response = await Api.post(`/finance/counterparties/delete`, data);
        const responseData = response.data;
        return responseData;
    }
}
